export default __webpack_public_path__ + "static/media/Rentio.10c5bbb8.png";